export default "__VITE_ASSET__DHqzTZzK__"